<template>
  <div class="modal-mask" v-show="value" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <!-- 头部 -->
        <div class="modal-header">
          <mt-button type="primary"  @click='confirm' style="background: transparent; border: none;">
            <img :src="closeImage" style="width: 24px; height: 24px;"/>
          </mt-button>
        </div>
        <div class="modal-header">
          <slot name="header"></slot>
        </div>
        <!-- 内容部分 -->
        <div class="modal-body">
          <slot class="modal-body" name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: false,
      closeImage: require('../assets/close.svg')
    }
  },
  mounted () {
    this.value = this.show
  },
  // 监听show数值的变化
  watch: {
    show: {
      handler: function (val, oldval) {
        this.value = val
      }
    }
  },
  methods: {
    cancel () {
      this.value = false
      // 向父组件传值
      this.$emit('listenToChildEvent', this.value)
    },
    confirm () {
      this.value = false
      // 向父组件传值
      this.$emit('listenToChildEvent', this.value)
    }
  }
}
</script>

<style  scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  horiz-align: center;
}

.modal-container {
  width: 40%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  margin-top: 0;
  text-align: right;
  font-weight:700;
}

.modal-header h3 {
  margin-top: 10px;
  text-align: center;
  font-weight:700;
}

.modal-body {
  font-family: "Arial","Microsoft YaHei","黑体","宋体",sans-serif;
  font-size:24px;
  line-height:30px;
  font-weight:400;
  text-align: center;
  color: #686868;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.modal-enter .modal-container,
.modal-leave .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media (max-width: 768px) {
  .modal-container {
    width: 80%;
    margin: auto;
    margin-right: 15px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header {
    margin-top: 0;
    text-align: right;
    font-weight:500;
  }

  .modal-header h3 {
    margin-top: 10px;
    text-align: center;
    font-weight:500;
  }

  .modal-body {
    font-family: "Arial","Microsoft YaHei","黑体","宋体",sans-serif;
    font-size:20px;
    line-height:30px;
    font-weight:500;
    text-align: center;
    color: #686868;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/modalDialog.vue